module.exports = __webpack_public_path__ + "static/media/amalraj.9a3ae3d4.jpg";